export const DietMealVariantCode = (json: IDietMealVariantCode): IDietMealVariantCodeModel => {
	const { meal_packaging_assignment_id, variant_id, ...rest } = json

	return {
		...rest,
		mealPackagingAssignmentId: meal_packaging_assignment_id,
		variantId: variant_id,
	}
}

export const DietMealVariant = (json: IDietMealVariant): IDietMealVariantModel => {
	const {
		id,
		meal,
		codes,
		meal_id,
		meal_size_id,
		preparation_time,
		is_active,
		has_same_components,
		meal_packaging_assignments,
		dietary_groups,
		components,
		nutritional_parameters,
		updated_at,
		created_at,
		...rest
	} = json

	return {
		...DietVariantPricesToModel(rest),
		id,
		meal: meal ? DietMeal(meal) : null,
		codes: safeMapOrNull(codes, DietMealVariantCode),
		mealId: meal_id,
		mealSizeId: meal_size_id,
		preparationTime: preparation_time,
		isActive: is_active,
		hasSameComponents: has_same_components,
		packagings: safeMap(meal_packaging_assignments, DietPackagingAssignment, []),
		groups: safeMap(dietary_groups, DietDietaryGroup, []),
		components: safeMap(components, DietMealComponent, []),
		nutritionalParameters: safeMapOrNull(nutritional_parameters, NutritionalParameterWithValue),
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}
